// extracted by mini-css-extract-plugin
module.exports = {"paginator_selector":"PaginationSelector_paginator_selector__cVQej"};